import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { useSelector } from 'react-redux';
import { ExpertsTermsAndAgreement } from '../ExpertsTermsAndAgreement';
import { AstrologyTermsContent } from './AstrologyTermsContent'; // Import the content
import { submitAstrologyOnboarding } from '../../../../../api/onboardingApis/astrologyOnboardingApi/astrologyOnboarding.api'; 
import type { RootState } from '@/store/store'; 

export const AstrologyFinalStep = () => {
  const expertData = useSelector((state: RootState) => state.expert.registrationData);
  const expertCode = useSelector((state: RootState) => state.expert.expertCode);

  const { handleSubmit, formState: { isSubmitting } } = useForm();

  const onAstrologySubmit = async () => {
    const fullName = expertData?.fullName || '';
    const categoryId = expertData?.categoryId || '';

    if (!expertCode) {
      toast.error("Expert code missing. Please re-login.");
      return;
    }

    if (categoryId === '1') {
      const payload = {
        expertCode: expertCode,
        categoryId: categoryId,
        expertName: fullName,
        isAcknowledged: true,
        isAgreementSigned: true
      };

      try {
        await submitAstrologyOnboarding(payload);
        toast.success('Astrology Expert Application Submitted Successfully! 🎉');
      } catch (error) {
        console.error("Submission error:", error);
        toast.error("Failed to submit application. Please try again.");
      }
    } else {
      toast.error("Invalid category for this onboarding step.");
    }
  };

  return (
    <ExpertsTermsAndAgreement
      roleName="Astrology Expert"
      onSubmit={handleSubmit(onAstrologySubmit)}
      isSubmitting={isSubmitting}
    >
      <AstrologyTermsContent />
    </ExpertsTermsAndAgreement>
  );
};